<template>
  <div class="container">
    <div class="tips-box">
      <img class="tips-img" src="../assets/img/h5/popup_warning_80@2x.png">
      <div class="tips-title">注销账号提示</div>
      <div class="tips-txt">账号一旦被注销将不可恢复，因此请你务必仔细阅读、充分理解以下须知。</div>
    </div>
    <div class="tips-desc-box">
      <div class="tips-desc-title">1.账号注销后，您的个人信息和与账号相关的内容都将无法找回</div>
      <div class="tips-desc-txt">包括但不限于：求职者身份下的在线/附件简历、投递和沟通记录、订单记录等；招聘者身份下已发布的职位、收到和下载的简历等。</div>
      <div class="tips-desc-txt">您需要在注销前自行备份相关信息和数据。</div><br/>
      <div class="tips-desc-title">2.账号资产将会被清空，也无法提供任何补偿或退还</div>
      <div class="tips-desc-txt">包括但不限于：勾豆、零钱等虚拟资产 、未到期的VIP账号权益、购买的课程 、其他在线增值服务等。</div>
      <div class="tips-desc-txt">您需要确认与拉勾账号相关的所有服务均已妥善处理。</div><br/>
      <div class="tips-desc-txt">注销此账号并不代表此账号注销前的行为和相关责任得到豁免或减轻。如您已仔细阅读上述【注销账号须知】后，仍执意注销您的账号，可点击按钮进行申请。如有其他问题，可联系客服4006-2828-35</div>
    </div>
    <div class="tips-footer">
      <div class="tips-footer-btn" @click="unregister">我已知悉，申请注销</div>
    </div>
    <ActionSheet v-model="showSheet" :close-on-click-overlay="false">
      <div class="sheet-title">选择注销原因</div>
      <div>
        <div class="sheet-lis"
          v-for="(reason, i) in reasonList"
          :key="i"
          @click="handleSelectReason(reason)"
        >{{ reason }}</div>
      </div>
      <div class="sheet-btn" @click="cancelSelect">取消</div>
    </ActionSheet>
    <div v-if="showModal" class="dialog-mask">
      <div class="dialog-content">
        <div class="dialog-con">
          <div class="dialog-title">注销账号申请确认</div>
          <div class="dialog-desc">我们会在7个工作日内完成审核并处理，期间将无法登录使用，注销成功后短信通知你，请到时留意查看</div>
        </div>
        <div class="dialog-footer">
          <div class="dialog-left-btn" @click="cancelShowModal">取消</div>
          <div class="dialog-right-btn" @click="handleSubmit">确认</div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { ActionSheet } from 'vant';
import { unregister } from "../../../service/api";
Vue.use(ActionSheet);
export default {
  name: "UnRegisterH5",
  components: {
    ActionSheet
  },
  data() {
    return {
      showSheet: false,
      showModal: false,
      reasonList: [
        "手机号重复，注销后重新注册",
        "效果不好，不会再使用",
        "随便下载看看，不再需要了",
        "其他原因"
      ],
      selectedReason: ''
    };
  },
  methods: {
    unregister() {
      this.selectedReason = "";
      this.showSheet = true;
    },
    handleSelectReason(reason) {
      this.selectedReason = reason;
      this.showSheet = false;
      this.showModal = true;
    },
    cancelSelect() {
      this.selectedReason = "";
      this.showSheet = false;
    },
    cancelShowModal() {
      this.selectedReason = "";
      this.showModal = false;
    },
    handleSubmit() {
      unregister({
        reason: this.selectedReason
      }).then(res => {
        window.lgBridge && window.lgBridge.request('userLoginForLogout');
      })
    }
  },
};
</script>
<style lang='less' scoped>
.container {
  overflow-y: auto;
  padding: 0 30px 150px 30px;
  box-sizing: border-box;
}
@supports (padding-bottom: constant(safe-area-inset-bottom)) or (padding-bottom: env(safe-area-inset-bottom)) {
  .container{
    padding-bottom: calc(150px + constant(safe-area-inset-bottom));
    padding-bottom: calc(150px + env(safe-area-inset-bottom));
  }
}
.tips-box {
  width: 100%;
  height: 318px;
  background-color: #F8F9FA;
  border-radius: 4px;
  margin-top: 40px;
  overflow: hidden;
  .tips-img {
    width: 80px;
    height: 80px;
    margin: 40px auto 20px;
    display: block;
  }
  .tips-title {
    height: 42px;
    font-size: 32px;
    font-family: PingFangSC-Medium, PingFang SC;
    font-weight: bold;
    color: #333333;
    line-height: 42px;
    text-align: center;
  }
  .tips-txt {
    width: 500px;
    height: 84px;
    font-size: 24px;
    font-family: PingFangSC-Regular, PingFang SC;
    color: #666666;
    line-height: 42px;
    margin: 0 auto;
    text-align: center;
    margin-top: 12px;
  }
}
.tips-desc-box {
  font-size: 28px;
  font-family: PingFangSC-Medium, PingFang SC;
  line-height: 56px;
  margin-top: 40px;
  .tips-desc-title {
    font-weight: bold;
    color: #333333;
  }
  .tips-desc-txt {
    color: #666666;
    font-weight: normal;
  }
}
.tips-footer {
  position: fixed;
  bottom: 0;
  left: 0;
  width: 100%;
  height: 130px;
  background-color: #fff;
  padding: 20px 30px 22px;
  box-sizing: border-box;
  z-index: 9;
  .tips-footer-btn {
    width: 100%;
    height: 88px;
    line-height: 88px;
    text-align: center;
    background: #FCD766;
    border-radius: 4px;
    font-size: 32px;
    font-family: PingFangSC-Medium, PingFang SC;
    font-weight: bold;
    color: #333333;
  }
}
@supports (padding-bottom: constant(safe-area-inset-bottom)) or (padding-bottom: env(safe-area-inset-bottom)) {
  .tips-footer{
    height: calc(130px + constant(safe-area-inset-bottom));
    height: calc(130px + env(safe-area-inset-bottom));
  }
}
.sheet-title {
  width: 100%;
  height: 120px;
  line-height: 120px;
  font-size: 32px;
  font-family: PingFangSC-Medium, PingFang SC;
  font-weight: bold;
  color: #333333;
  text-align: center;
  border-bottom: 5px solid #F8F9FA;
}
.sheet-lis {
  width: 100%;
  height: 120px;
  line-height: 120px;
  font-size: 32px;
  font-family: PingFangSC-Medium, PingFang SC;
  font-weight: normal;
  color: #666666;
  text-align: center;
  border-bottom: 1px solid #E8E9EB;
  &:last-child {
    border-bottom: none;
  }
}
.sheet-btn {
  width: 100%;
  height: 136px;
  line-height: 136px;
  font-size: 36px;
  font-family: PingFangSC-Medium, PingFang SC;
  font-weight: normal;
  color: #666666;
  text-align: center;
  border-top: 5px solid #F8F9FA;
}
/deep/ .van-overlay {
  background-color: rgba(0, 0, 0, .5);
}
/deep/ .van-popup--bottom.van-popup--round {
  border-radius: 10px 10px 0 0;
}
.dialog-mask {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  z-index: 999;
  background: rgba(0, 0, 0, .5);
  .dialog-content {
    position: relative;
    left: 50%;
    top: 40%;
    width: 600px;
    height: 409px;
    background-color: #fff;
    border-radius: 8px;
    transform: translate(-50%, -50%);
    .dialog-con {
      width: 100%;
      height: 300px;
      overflow: hidden;
      .dialog-title {
        height: 50px;
        font-size: 36px;
        font-family: PingFangSC-Medium, PingFang SC;
        font-weight: bold;
        color: #333333;
        line-height: 50px;
        margin-top: 60px;
        text-align: center;
      }
      .dialog-desc {
        width: 500px;
        font-size: 28px;
        font-family: PingFangSC-Regular, PingFang SC;
        font-weight: normal;
        color: #666666;
        line-height: 42px;
        margin: 12px auto 0;
        text-align: center;
      }
    }
    .dialog-footer {
      display: flex;
      width: 100%;
      height: 100px;
      border-top: 1px solid #E6E6E6;
      .dialog-left-btn {
        flex: 1;
        height: 100px;
        line-height: 100px;
        text-align: center;
        font-size: 32px;
        font-family: PingFangSC-Regular, PingFang SC;
        font-weight: normal;
        color: #666666;
        border-right: 1px solid #E6E6E6;
      }
      .dialog-right-btn {
        flex: 1;
        height: 100px;
        line-height: 100px;
        text-align: center;
        font-size: 32px;
        font-family: PingFangSC-Regular, PingFang SC;
        font-weight: normal;
        color: #5580C8;
      }
    }
  }
}
</style>
